import { useEffect } from "react";

const DownloadRedirect = () => {
    useEffect(() => {
    fetch("/recordsBrowserDownload.html")
      .then(r => r.text())
      .then(html => {
        document.open();
        document.write(html);
        document.close();
      });
  }, []);

  return null;
};

export default DownloadRedirect;
